
import React from 'react';
import styled from 'styled-components';
import { isDesktop, isTab, isInIframe } from '../utils/globalConfig';
import { Button } from "@vds/buttons";
import { Line } from '@vds/lines';
import PropTypes from 'prop-types';
const PrimaryButton = styled(Button)`
position: ${props => props.pt? "sticky" : "" };
float:${isDesktop ? 'right' : 'none'};
bottom:7px;
z-index:7;
margin-bottom:70px;
left:${isTab ? '20%' : ''};
`;

const StyledLine = styled(Line)`
margin-bottom: 10px;
`

const Footer = ({ ctaLabel, disabled, handleButtonChange, btnType,ariaLabel, btn, confirmedPlanDataLength, ctaLabel2, btn2, dataTrack}) => {

    const handleButtonClick = () => {
        handleButtonChange();
    }

    let buttonWidth = '100%';
    if (!isInIframe && isDesktop) {
        buttonWidth = '30%';
    } else if (isTab) {
        buttonWidth = '50%';
    }

    return (
        <>
            <StyledLine type="secondary" />
            <PrimaryButton
                aria-label={ariaLabel}
                data-track={dataTrack}
                size="large"
                data-testid="footerButton"
                width={buttonWidth}
                disabled={disabled}
                use={btnType ? btnType : "primary"}
                pt = {btn}
                onClick={() => handleButtonClick()}
            >{(confirmedPlanDataLength && (btn || btn2)) ? ctaLabel2 : ctaLabel}
            </PrimaryButton>
        </>

    )
}
Footer.propTypes = {
    ctaLabel: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    handleButtonChange: PropTypes.func.isRequired,
    btnType: PropTypes.string,
    ariaLabel: PropTypes.string,
    btn: PropTypes.bool,
    btn2: PropTypes.bool,
    confirmedPlanDataLength: PropTypes.number,
    ctaLabel2: PropTypes.string,
};
export default Footer;